import { useKeyPress } from "./useKeyPress";
import { shortcuts } from "../utils/shortcuts";
import { useClipBoard } from "../contexts/ClipboardContext";
import { useFileNavigation } from "../contexts/FileNavigationContext";
import { useSelection } from "../contexts/SelectionContext";
import { useLayout } from "../contexts/LayoutContext";
import { validateApiCallback } from "../utils/validateApiCallback";

export const useShortcutHandler = (triggerAction, onRefresh) => {
  const { setClipBoard, handleCutCopy, handlePasting, clipBoard } = useClipBoard(); // Добавляем clipBoard
  const { currentFolder, currentPathFiles } = useFileNavigation();
  const { setSelectedFiles, handleDownload, selectedFiles } = useSelection(); // Добавляем selectedFiles
  const { setActiveLayout } = useLayout();

  const triggerCreateFolder = () => {
    triggerAction.show("createFolder");
  };

  const triggerUploadFiles = () => {
    triggerAction.show("uploadFile");
  };

  const triggerCutItems = () => {
    // Проверяем, есть ли выбранные файлы
    if (!selectedFiles || selectedFiles.length === 0) return;
    handleCutCopy(true);
  };

  const triggerCopyItems = () => {
    // Проверяем, есть ли выбранные файлы
    if (!selectedFiles || selectedFiles.length === 0) return;
    handleCutCopy(false);
  };

  const triggerPasteItems = () => {
    // ВАЖНО: Проверяем, есть ли что вставлять и не в поле ли ввода фокус
    const activeElement = document.activeElement;
    const isInputFocused = activeElement.tagName === 'INPUT' || 
                          activeElement.tagName === 'TEXTAREA';
    
    // Если фокус в поле ввода - не обрабатываем вставку файлов
    if (isInputFocused) {
      return;
    }
    
    // Проверяем буфер обмена
    if (!clipBoard || !clipBoard.files || clipBoard.files.length === 0) {
      console.warn("Nothing to paste");
      return;
    }
    
    handlePasting(currentFolder);
  };

  const triggerRename = () => {
    // Проверяем, есть ли выбранные файлы и только один
    if (!selectedFiles || selectedFiles.length !== 1) return;
    triggerAction.show("rename");
  };

  const triggerDownload = () => {
    handleDownload();
  };

  const triggerDelete = () => {
    // Проверяем, есть ли выбранные файлы
    if (!selectedFiles || selectedFiles.length === 0) return;
    triggerAction.show("delete");
  };

  const triggerSelectFirst = () => {
    if (currentPathFiles.length > 0) {
      setSelectedFiles([currentPathFiles[0]]);
    }
  };

  const triggerSelectLast = () => {
    if (currentPathFiles.length > 0) {
      setSelectedFiles([currentPathFiles.at(-1)]);
    }
  };

  const triggerSelectAll = () => {
    setSelectedFiles(currentPathFiles);
  };

  const triggerClearSelection = () => {
    setSelectedFiles((prev) => (prev.length > 0 ? [] : prev));
  };

  const triggerRefresh = () => {
    validateApiCallback(onRefresh, "onRefresh");
    setClipBoard(null);
  };

  const triggerGridLayout = () => {
    setActiveLayout("grid");
  };
  const triggerListLayout = () => {
    setActiveLayout("list");
  };

  // Keypress detection will be disabled when some Action is in active state.
  useKeyPress(shortcuts.createFolder, triggerCreateFolder, triggerAction.isActive);
  useKeyPress(shortcuts.uploadFiles, triggerUploadFiles, triggerAction.isActive);
  useKeyPress(shortcuts.cut, triggerCutItems, triggerAction.isActive);
  useKeyPress(shortcuts.copy, triggerCopyItems, triggerAction.isActive);
  useKeyPress(shortcuts.paste, triggerPasteItems, triggerAction.isActive);
  useKeyPress(shortcuts.rename, triggerRename, triggerAction.isActive);
  useKeyPress(shortcuts.download, triggerDownload, triggerAction.isActive);
  useKeyPress(shortcuts.delete, triggerDelete, triggerAction.isActive);
  useKeyPress(shortcuts.jumpToFirst, triggerSelectFirst, triggerAction.isActive);
  useKeyPress(shortcuts.jumpToLast, triggerSelectLast, triggerAction.isActive);
  useKeyPress(shortcuts.selectAll, triggerSelectAll, triggerAction.isActive);
  useKeyPress(shortcuts.clearSelection, triggerClearSelection, triggerAction.isActive);
  useKeyPress(shortcuts.refresh, triggerRefresh, triggerAction.isActive);
  useKeyPress(shortcuts.gridLayout, triggerGridLayout, triggerAction.isActive);
  useKeyPress(shortcuts.listLayout, triggerListLayout, triggerAction.isActive);
};